import { connect } from 'react-redux'
import DownloadAttachmentsPage from '../components/DownloadAttachmentsPage'

const mapStateToProps = (state, ownProps) => {
    return {
        benchVisulizationImage: state.materialImage.image.indexOf(".png")<0 ? state.materialImage.image : "",
        benchCadImage: state.benchModel.cadImage
    }
}

const DownloadAttachmentsPageContainer = connect(
    mapStateToProps
)(DownloadAttachmentsPage)

export default DownloadAttachmentsPageContainer